import {
  Card,
  CardContent,
  CardHeader,
  Fab,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ElektronickaAdresa, ElektronickaAdresaTip } from "../../../index";
import RemoveIcon from "@mui/icons-material/Remove";
import { useFieldArray } from "react-hook-form";

const Index = ({ nazivPolja }: { nazivPolja: string }) => {
  const { fields, append, remove, update } = useFieldArray({
    name: nazivPolja,
  });

  const dodaj = () => {
    append({
      adresa: "",
      tip: {
        id: "",
        opis: "",
      },
    });
  };

  const ukloni = (index: number) => {
    remove(index);
  };

  return (
    <Card variant={"outlined"} sx={{ mt: 3, position: "relative" }}>
      <CardHeader
        title={"Elektroničke adrese (Electronic addresses)"}
        titleTypographyProps={{ variant: "h6" }}
      />
      <CardContent>
        <TableContainer component={Paper} variant={"outlined"}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell width={"30%"}>
                  Elektronička adresa (Electronic address)
                </TableCell>
                <TableCell width={"50%"}>Tip adrese</TableCell>
                <TableCell width={"10%"} align={"right"}>
                  <Tooltip title={"Dodaj (Add)"}>
                    <Fab size={"small"} aria-label="settings" onClick={dodaj}>
                      <AddIcon />
                    </Fab>
                  </Tooltip>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fields.map((field, key) => (
                <TableRow
                  key={key}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {key + 1}
                  </TableCell>
                  <TableCell>
                    <ElektronickaAdresa
                      nazivPolja={`${nazivPolja}[${key}].adresa`}
                    />
                  </TableCell>
                  <TableCell>
                    <ElektronickaAdresaTip
                      nazivPolja={`${nazivPolja}[${key}].tip.id`}
                      nazivPoljaOpis={`${nazivPolja}[${key}].tip.opis`}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <Tooltip title={"Ukloni (Remove)"}>
                      <IconButton
                        aria-label="settings"
                        sx={{ marginTop: "8px" }}
                        onClick={() => ukloni(key)}
                      >
                        <RemoveIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default Index;
